// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { MessageModalCoachFragmentDoc } from '../modals/MessageModal/__generated-gql-types__/index.generated';
import {
  ScheduleModalCoachFragmentDoc,
  ScheduleModalCoachingSessionFragmentDoc,
} from '../modals/__generated-gql-types__/ScheduleModal.generated';
import { RequestCoachMatchModalCoachFragmentDoc } from '../modals/__generated-gql-types__/RequestCoachMatchModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachBottomMessageCtaCoachFragment = {
  __typename?: 'Coach';
  id: string;
  reviewTotal: number;
  averageReviewRate: number;
  visibility: Types.CoachVisibility;
  tier: Types.SkuTier;
  slug: string;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  user: {
    __typename?: 'User';
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
    id: string;
  };
  matchedCoach?: {
    __typename?: 'MatchedCoach';
    id: string;
    status: Types.MatchedCoachStatus;
  } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
    defaultAvailability?: {
      __typename?: 'DefaultAvailability';
      totalInMinute: number;
    } | null;
  } | null;
  mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    category: { __typename?: 'Category'; id: string; name: string };
  }> | null;
};

export type CoachBottomMessageCtaUserFragment = {
  __typename?: 'User';
  id: string;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    hasUnassignedTrialOrder?: boolean | null;
  } | null;
};

export type CoachBottomMessageCtaGetUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CoachBottomMessageCtaGetUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      hasUnassignedTrialOrder?: boolean | null;
    } | null;
  } | null;
};

export type CoachBottomMessageCtaGetCoachByIdQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type CoachBottomMessageCtaGetCoachByIdQuery = {
  __typename?: 'Query';
  coach?: {
    __typename?: 'Coach';
    id: string;
    reviewTotal: number;
    averageReviewRate: number;
    visibility: Types.CoachVisibility;
    tier: Types.SkuTier;
    slug: string;
    couldScheduleIntro?: boolean | null;
    everHadCoachingSessionWithCoach?: boolean | null;
    hourlyRate?: number | null;
    user: {
      __typename?: 'User';
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      id: string;
    };
    matchedCoach?: {
      __typename?: 'MatchedCoach';
      id: string;
      status: Types.MatchedCoachStatus;
    } | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      paidTimeInMinute?: number | null;
      customerSubscription?: {
        __typename?: 'CustomerSubscription';
        id: string;
        sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      } | null;
    } | null;
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
      defaultAvailability?: {
        __typename?: 'DefaultAvailability';
        totalInMinute: number;
      } | null;
    } | null;
    mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      availableTime: number;
      hasUnlimitedPackage: boolean;
      cycles?: Array<{
        __typename?: 'SubscriptionCycle';
        timeInMinute: number;
        start?: number | null;
        end?: number | null;
      }> | null;
    } | null;
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      id: string;
      category: { __typename?: 'Category'; id: string; name: string };
    }> | null;
  } | null;
};

export type CoachBottomMessageCtaLinkedInSelfServeRequestMutationVariables =
  Types.Exact<{
    input: Types.MatchedCoachInput;
  }>;

export type CoachBottomMessageCtaLinkedInSelfServeRequestMutation = {
  __typename?: 'Mutation';
  createOpportunity: {
    __typename?: 'MatchedCoach';
    id: string;
    status: Types.MatchedCoachStatus;
    coach?: {
      __typename?: 'Coach';
      id: string;
      matchedCoach?: {
        __typename?: 'MatchedCoach';
        id: string;
        status: Types.MatchedCoachStatus;
      } | null;
    } | null;
  };
};

export const CoachBottomMessageCtaCoachFragmentDoc = gql`
  fragment CoachBottomMessageCTA_Coach on Coach {
    id
    user {
      firstName
      lastName
      pictureLink
    }
    matchedCoach {
      id
      status
    }
    coachingRelationship {
      id
    }
    reviewTotal
    averageReviewRate
    availability {
      defaultAvailability {
        totalInMinute
      }
    }
    visibility
    mostRecentOrder {
      id
    }
    ...MessageModal_Coach
    ...ScheduleModal_Coach
    ...RequestCoachMatchModal_Coach
  }
  ${MessageModalCoachFragmentDoc}
  ${ScheduleModalCoachFragmentDoc}
  ${RequestCoachMatchModalCoachFragmentDoc}
`;
export const CoachBottomMessageCtaUserFragmentDoc = gql`
  fragment CoachBottomMessageCTA_User on User {
    id
    applicant {
      id
      hasUnassignedTrialOrder
    }
  }
`;
export const CoachBottomMessageCtaGetUserDocument = gql`
  query CoachBottomMessageCTA_GetUser {
    user {
      ...CoachBottomMessageCTA_User
    }
  }
  ${CoachBottomMessageCtaUserFragmentDoc}
`;

/**
 * __useCoachBottomMessageCtaGetUserQuery__
 *
 * To run a query within a React component, call `useCoachBottomMessageCtaGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBottomMessageCtaGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBottomMessageCtaGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachBottomMessageCtaGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachBottomMessageCtaGetUserQuery,
    CoachBottomMessageCtaGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachBottomMessageCtaGetUserQuery,
    CoachBottomMessageCtaGetUserQueryVariables
  >(CoachBottomMessageCtaGetUserDocument, options);
}
export function useCoachBottomMessageCtaGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachBottomMessageCtaGetUserQuery,
    CoachBottomMessageCtaGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachBottomMessageCtaGetUserQuery,
    CoachBottomMessageCtaGetUserQueryVariables
  >(CoachBottomMessageCtaGetUserDocument, options);
}
export function useCoachBottomMessageCtaGetUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CoachBottomMessageCtaGetUserQuery,
    CoachBottomMessageCtaGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachBottomMessageCtaGetUserQuery,
    CoachBottomMessageCtaGetUserQueryVariables
  >(CoachBottomMessageCtaGetUserDocument, options);
}
export type CoachBottomMessageCtaGetUserQueryHookResult = ReturnType<
  typeof useCoachBottomMessageCtaGetUserQuery
>;
export type CoachBottomMessageCtaGetUserLazyQueryHookResult = ReturnType<
  typeof useCoachBottomMessageCtaGetUserLazyQuery
>;
export type CoachBottomMessageCtaGetUserSuspenseQueryHookResult = ReturnType<
  typeof useCoachBottomMessageCtaGetUserSuspenseQuery
>;
export type CoachBottomMessageCtaGetUserQueryResult = Apollo.QueryResult<
  CoachBottomMessageCtaGetUserQuery,
  CoachBottomMessageCtaGetUserQueryVariables
>;
export const CoachBottomMessageCtaGetCoachByIdDocument = gql`
  query CoachBottomMessageCTA_GetCoachById($coachUrn: CoachUrn!) {
    coach(id: $coachUrn) {
      ...CoachBottomMessageCTA_Coach
    }
  }
  ${CoachBottomMessageCtaCoachFragmentDoc}
`;

/**
 * __useCoachBottomMessageCtaGetCoachByIdQuery__
 *
 * To run a query within a React component, call `useCoachBottomMessageCtaGetCoachByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBottomMessageCtaGetCoachByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBottomMessageCtaGetCoachByIdQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function useCoachBottomMessageCtaGetCoachByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachBottomMessageCtaGetCoachByIdQuery,
    CoachBottomMessageCtaGetCoachByIdQueryVariables
  > &
    (
      | {
          variables: CoachBottomMessageCtaGetCoachByIdQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachBottomMessageCtaGetCoachByIdQuery,
    CoachBottomMessageCtaGetCoachByIdQueryVariables
  >(CoachBottomMessageCtaGetCoachByIdDocument, options);
}
export function useCoachBottomMessageCtaGetCoachByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachBottomMessageCtaGetCoachByIdQuery,
    CoachBottomMessageCtaGetCoachByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachBottomMessageCtaGetCoachByIdQuery,
    CoachBottomMessageCtaGetCoachByIdQueryVariables
  >(CoachBottomMessageCtaGetCoachByIdDocument, options);
}
export function useCoachBottomMessageCtaGetCoachByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CoachBottomMessageCtaGetCoachByIdQuery,
    CoachBottomMessageCtaGetCoachByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachBottomMessageCtaGetCoachByIdQuery,
    CoachBottomMessageCtaGetCoachByIdQueryVariables
  >(CoachBottomMessageCtaGetCoachByIdDocument, options);
}
export type CoachBottomMessageCtaGetCoachByIdQueryHookResult = ReturnType<
  typeof useCoachBottomMessageCtaGetCoachByIdQuery
>;
export type CoachBottomMessageCtaGetCoachByIdLazyQueryHookResult = ReturnType<
  typeof useCoachBottomMessageCtaGetCoachByIdLazyQuery
>;
export type CoachBottomMessageCtaGetCoachByIdSuspenseQueryHookResult =
  ReturnType<typeof useCoachBottomMessageCtaGetCoachByIdSuspenseQuery>;
export type CoachBottomMessageCtaGetCoachByIdQueryResult = Apollo.QueryResult<
  CoachBottomMessageCtaGetCoachByIdQuery,
  CoachBottomMessageCtaGetCoachByIdQueryVariables
>;
export const CoachBottomMessageCtaLinkedInSelfServeRequestDocument = gql`
  mutation CoachBottomMessageCTA_LinkedInSelfServeRequest(
    $input: MatchedCoachInput!
  ) {
    createOpportunity(input: $input) {
      id
      status
      coach {
        id
        matchedCoach {
          id
          status
        }
      }
    }
  }
`;
export type CoachBottomMessageCtaLinkedInSelfServeRequestMutationFn =
  Apollo.MutationFunction<
    CoachBottomMessageCtaLinkedInSelfServeRequestMutation,
    CoachBottomMessageCtaLinkedInSelfServeRequestMutationVariables
  >;

/**
 * __useCoachBottomMessageCtaLinkedInSelfServeRequestMutation__
 *
 * To run a mutation, you first call `useCoachBottomMessageCtaLinkedInSelfServeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachBottomMessageCtaLinkedInSelfServeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachBottomMessageCtaLinkedInSelfServeRequestMutation, { data, loading, error }] = useCoachBottomMessageCtaLinkedInSelfServeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachBottomMessageCtaLinkedInSelfServeRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CoachBottomMessageCtaLinkedInSelfServeRequestMutation,
    CoachBottomMessageCtaLinkedInSelfServeRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CoachBottomMessageCtaLinkedInSelfServeRequestMutation,
    CoachBottomMessageCtaLinkedInSelfServeRequestMutationVariables
  >(CoachBottomMessageCtaLinkedInSelfServeRequestDocument, options);
}
export type CoachBottomMessageCtaLinkedInSelfServeRequestMutationHookResult =
  ReturnType<typeof useCoachBottomMessageCtaLinkedInSelfServeRequestMutation>;
export type CoachBottomMessageCtaLinkedInSelfServeRequestMutationResult =
  Apollo.MutationResult<CoachBottomMessageCtaLinkedInSelfServeRequestMutation>;
export type CoachBottomMessageCtaLinkedInSelfServeRequestMutationOptions =
  Apollo.BaseMutationOptions<
    CoachBottomMessageCtaLinkedInSelfServeRequestMutation,
    CoachBottomMessageCtaLinkedInSelfServeRequestMutationVariables
  >;
